import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo, useState } from "react";
import darkTheme from "./Farther/darkValues";
import lightTheme from "./Farther/lightValues";
const themes = ["Farther"];
const appearances = ["light", "dark"];
const ThemeValueDatabase = { Farther: { light: { color: lightTheme }, dark: { color: darkTheme } } };
const ThemeContext = createContext({
    themes: themes,
    appearances: appearances,
    changeTheme: () => {
        return;
    },
    changeAppearance: () => {
        return;
    },
    currentAppearance: { color: darkTheme },
    currentTheme: "Farther",
});
ThemeContext.displayName = "ThemeContext";
export const ThemeProvider = ({ defaultTheme = "Farther", defaultAppearance = "dark", ...props }) => {
    const [currentTheme, setTheme] = useState(defaultTheme);
    const [currentAppearance, setAppearance] = useState(defaultAppearance);
    const allThemeValues = useMemo(() => ({ ...ThemeValueDatabase }), []);
    // do not allow user's to modify our list of theme values
    const currentValues = useMemo(() => Object.freeze({ ...allThemeValues[currentTheme][currentAppearance] }), [allThemeValues, currentTheme, currentAppearance]);
    const themeChoices = useMemo(() => Object.freeze(Object.keys(allThemeValues)), [allThemeValues]);
    const appearanceChoices = useMemo(() => Object.freeze(Object.keys(allThemeValues[currentTheme])), [allThemeValues, currentTheme]);
    return (_jsx(ThemeContext.Provider, { value: {
            changeTheme: setTheme,
            changeAppearance: setAppearance,
            currentAppearance: currentValues,
            currentTheme,
            themes: themeChoices,
            appearances: appearanceChoices,
        }, children: props.children }));
};
export const useTheme = () => {
    const { currentAppearance } = useContext(ThemeContext);
    return currentAppearance;
};
export const useThemeChanger = () => {
    const { changeTheme } = useContext(ThemeContext);
    return changeTheme;
};
export const useAppearanceChanger = () => {
    const { changeAppearance } = useContext(ThemeContext);
    return changeAppearance;
};
/**
 * Wraps a react component and provides the following props `theme: AppearanceValues`
 * @param Component React Component to provide props to
 * @returns `React Component`
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withTheme(Component) {
    const WithTheme = (props, ref) => {
        const theme = useTheme();
        // @ts-expect-error: 'ref' as never
        return _jsx(Component, { ...props, ref: ref, theme: theme });
    };
    return React.forwardRef(WithTheme);
}
//# sourceMappingURL=ThemeProvider.js.map